module.exports = __webpack_public_path__ + "static/llt-logo-c134c988fe34dbeb2a38e4a305fc475f.jpg";